'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providers = undefined;

var _sellerTypes = require('./applications/changeProvider/sellerTypes.js');

var _sellerTypes2 = _interopRequireDefault(_sellerTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var providers = exports.providers = [{
  appDefId: '147bec5f-d87e-d37b-b5cf-36f47c1815b4', // Wix
  appMarketId: 'wix-pro-gallery-provider',
  sellerText: 'Wix',
  languageKeys: {
    termsOfUse: 'ChangeProvider_Switching_PopUp_OAP_Agreement_Terms_WIX_Link',
    sellTypeKey: 'ChangeProvider_Switch_Screen_Digital_Title',
    fulfilledBy: 'ChangeProvider_Switch_Screen_Provider_Wix',
    sellDescriptionKey: 'ChangeProvider_Switch_Screen_Provider_Wix_Description',
    sellTypeButtonKey: 'ChangeProvider_Switch_Screen_Provider_Digital_Button',
    youveChosenKey: 'ChangeProvider_Switching_PopUp_Wix_Title',
    changeProviderAlertKey: 'ChangeProvider_Switching_PopUp_Wix_Description_Line2',
    comparisonHeaderKey: 'ChangeProvider_Comparison_Chart_Digital_Label',
    nameKey: 'ChangeProvider_Comparison_Chart_Wix_Label',
    nameCartKey: 'ChangeProvider_Switch_Screen_Wix_Label',
    comparisonToolTip: 'ChangeProvider_Comparison_Chart_List_Tooltip_Wix_Text',
    comparisonToolTipLearnMore: 'ChangeProvider_Comparison_Chart_List_Tooltip_Wix_Learn More_Label',
    sellTypeMiniKey: 'Editor_Store_Provider_Digital_Label',
    wizardStep3ActiveText: 'Editor_Store_StepThree_Text_Wix_Active_Text',
    wizardStep3InActiveText: 'Editor_Store_StepThree_Text_Wix_Inactive_Text',
    wizardStep3InActiveLinkText: 'Editor_Store_StepThree_Text_Wix_Inactive_Link_Text'
  },
  supportArticles: {
    pricing: '2f7a901a-5ad2-427c-80dd-2b411e276bc6',
    manage: '1055bc6b-b7bc-4eb6-9a82-be4947ebe0cf'
  },
  sellerType: _sellerTypes2.default.digital,
  payments: true,
  // fulfilmentfee: true,
  preventTOU: true,
  sellDigitalImagesFiles: true,
  highQualityFileDownloads: true,
  customMadeImageLicenses: true,
  commitionFree: true,
  fullServiceProductPrinting: false,
  mugs: false,
  cups: false,
  canvasWraps: false,
  photoPrints: false,
  toteBags: false,
  framedPrints: false,
  acrylicPrints: false,
  pillows: false,
  metalPrints: false,
  artPosters: false,
  phoneCases: false,
  acrylicBlocks: false,
  ceramicMugs: false,
  Support247: true,
  creditCardPaymentsAccepted: true,
  payPalConnection: true,
  hasAddToCartButton: true,
  noTransactionFee: true
}, {
  appDefId: '14a9911b-a59e-b7f3-f878-3661e0d83f2f', // B2C
  appMarketId: 'progallerysellphotos',
  sellerText: 'B2C',
  languageKeys: {
    termsOfUse: 'ChangeProvider_Switching_PopUp_OAP_Agreement_Terms_OAP_Link',
    sellTypeKey: 'ChangeProvider_Switch_Screen_Digital_Print_Title',
    fulfilledBy: 'ChangeProvider_Switch_Screen_Provider_OrderAPrint',
    sellDescriptionKey: 'ChangeProvider_Switch_Screen_Provider_OrderAPrint_Description',
    sellTypeButtonKey: 'ChangeProvider_Switch_Screen_Provider_DigitalPrint_Button',
    youveChosenKey: 'ChangeProvider_Switching_PopUp_OAP_Title',
    changeProviderAlertKey: 'ChangeProvider_Switching_PopUp_OAP_Description_Line1',
    comparisonHeaderKey: 'ChangeProvider_Comparison_Chart_Digital_Print_Label',
    nameKey: 'ChangeProvider_Comparison_Chart_OrderAPrint_Label',
    nameCartKey: 'ChangeProvider_Switch_Screen_OrderAPrint_Label',
    comparisonToolTip: 'ChangeProvider_Comparison_Chart_List_Tooltip_OAP_Text',
    comparisonToolTipLearnMore: 'ChangeProvider_Comparison_Chart_List_Tooltip_OAP_Learn More_Label',
    sellTypeMiniKey: 'Editor_Store_Provider_Digital_Print_Label',
    wizardStep3ActiveText: 'Editor_Store_StepThree_Text',
    wizardStep3InActiveText: 'Editor_Store_StepThree_Text'
  },
  supportArticles: {
    pricing: 'b94a61b8-32a2-4d6c-92e7-009d2ae57251',
    manage: 'b68a30b0-d967-4683-bc65-db45c64aab6e'
  },
  sellerType: _sellerTypes2.default.digitalAndPrints,
  supportLink: 'https://www.orderaprint.com/art-store/products?layout=none',
  payments: true,
  international: true,
  customMadeImageLicenses: false,
  fulfilmentfee: true,
  sellDigitalImagesFiles: true,
  highQualityFileDownloads: true,
  commitionFree: true,
  fullServiceProductPrinting: true,
  mugs: true,
  cups: true,
  canvasWraps: true,
  photoPrints: true,
  toteBags: true,
  framedPrints: true,
  acrylicPrints: true,
  pillows: true,
  metalPrints: true,
  artPosters: true,
  phoneCases: true,
  acrylicBlocks: true,
  ceramicMugs: true,
  Support247: true,
  creditCardPaymentsAccepted: true,
  payPalConnection: true,
  termsOfUseLink: 'https://www.orderaprint.com/art-store/terms',
  hasAddToCartButton: false,
  noTransactionFee: false
}];